<div class="empty-state__icon" data-testid="empty-state-icon">
  <mat-icon class="empty-state__wheel-icon">donut_large</mat-icon>
</div>

<div class="empty-state__actions" data-testid="empty-state-actions">
  <h2>Verify your email to start using the Wheel</h2>
  <p>
    We’ve sent a link to {{ email$ | async }}. </p>
  <p>Didn't get it? Request another link in your
    <button type="button" class="empty-state__profile-link" (click)="navigateToProfile()" data-testid="email-verification-page-link">
      {{ "profile" | translate }}
    </button>
  </p>
</div>
